import React, { PureComponent } from 'react'
import { FORM_ERROR } from 'final-form'
import PropTypes from 'prop-types'
import { Form, Field } from 'react-final-form'
import validate from 'validate.js'
import { Button, InputField } from '@mc/design-system'
import { withTranslation } from '@mc/i18n'
import { CONFIRM_PASSWORD_TITLE } from '../constants'
import { confirmPassword, redirect } from '../services'

const constraints = {
  password_confirmation: {
    presence: { message: 'Password is required' },
  },
}

class ConfirmPasswordForm extends PureComponent {
  static propTypes = {
    auth: PropTypes.object,
    t: PropTypes.func,
  }

  handleSubmit = async (values) => {
    const { auth, afterAuthAction } = this.props
    try {
      const res = await confirmPassword({ ...values, ...auth })
      if (afterAuthAction) {
        afterAuthAction(res)
      }

      redirect(res)
      return {}
    } catch (error) {
      return { [FORM_ERROR]: 'Something went wrong, please try again' }
    }
  }

  render() {
    const { t } = this.props
    return (
      <div>
        <h4 className='mc-text-h4 mc-mb-6 mc-text--center'>
          {CONFIRM_PASSWORD_TITLE}
        </h4>

        <p className='mc-opacity--hinted mc-text--center mc-mb-4'>
          {t('confirmPasswordForm.existingMasterClassAccount')}
        </p>

        <Form
          onSubmit={this.handleSubmit}
          validate={(values) =>
            validate(values, constraints, { fullMessages: false })
          }
          render={({ handleSubmit, submitting, submitError }) => (
            <form onSubmit={handleSubmit}>
              {submitError && (
                <p className='mc-text--error mc-text--center mc-mb-4'>
                  {submitError}
                </p>
              )}

              <Field
                component={InputField}
                className='mc-mb-4'
                name='password_confirmation'
                type='password'
                label='Create a password to link your account'
                required
              />

              <Button type='submit' loading={submitting} fullWidth>
                {t('confirmPasswordForm.continue')}
              </Button>
            </form>
          )}
        />
      </div>
    )
  }
}

export default withTranslation('@mc/authentication')(ConfirmPasswordForm)
